import { t } from 'i18next';
import { RedirectPage } from '../../../components/redirect-page';
import { platformLabel, useEnv } from '../../../context/env-context';
import { withPageProviders } from '../../../context/page-context';

export const FeaturesRedirectPage = withPageProviders(FeaturesRedirectContent);

function FeaturesRedirectContent() {
  const platform = platformLabel(useEnv().connected_platform);

  return (
    <RedirectPage
      path="/features"
      title={t('features:explore.pages.redirect.title', { platform })}
      subtitle={t('features:explore.pages.redirect.description', { platform })}
      action={t('features:explore.pages.redirect.action', { platform })}
      imageType="themes"
    />
  );
}
